import { combineReducers } from 'redux';
import { loadingStatusAccordingToReducer } from 'utils/reducers/loading-status/loading-status';
import selectedMessages from './selected-messages';
import sent from './sent';
import inbox from './inbox';
import unreadCount from './unread-count';
import messageDetails from './message-details';
import recipients from './recipients';

const messages = combineReducers({
  selectedMessages,
  inbox,
  sent,
  unreadCount,
  recipients,
  inboxLoadingStatus: loadingStatusAccordingToReducer('inboxLoadingStatus'),
  sentLoadingStatus: loadingStatusAccordingToReducer('sentLoadingStatus'),
  recipientsLoadingStatus: loadingStatusAccordingToReducer('recipientsLoadingStatus'),
  messageDetailsLoadingStatus: loadingStatusAccordingToReducer('messageDetailsLoadingStatus'),
  selectedMessage: messageDetails,
});

export default messages;



// WEBPACK FOOTER //
// ./src/modules/message/reducers/messages.reducer.js